import styled from "styled-components"

export const ConfirmButtonsContainer = styled.div `

    width: 90%;
    height: 90%;
    display: grid;
    grid-auto-flow: column;

`